<template>
  <section
    class="app-main"
    :class="{p0: minimalistPage}"
    v-loading="!visible"
    element-loading-spinner="el-icon-loading"
  >
    <router-view v-if="visible"></router-view>
  </section>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  name: "AppMain",
  data() {
    return {
      visible: true
    };
  },
  computed: {
    minimalistPage() {
      return this.$route.meta.minimalistPage;
    },
  },
  mounted() {
    Bus.$on("companyReady", () => {
      this.visible = true;
    });
  }
};
</script>
<style lang="scss" scoped>
.app-main {
  position: relative;
  min-height: calc(100vh - 100px);
  padding: 14px 26px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
